import { render, staticRenderFns } from "./MassagesLink.vue?vue&type=template&id=324b5a6a&"
import script from "./MassagesLink.vue?vue&type=script&lang=js&"
export * from "./MassagesLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports